
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class PhoneTo extends Vue {
    @Prop({ type: String, default: undefined }) readonly phone?: string;

    get phoneHref(): string | undefined {
      if (!this.phone) {
        return undefined;
      }
      return `tel:${this.phone}`;
    }
  }
